export const SENTRY = {
  DSN: import.meta.env.VITE_SENTRY_DSN || '',
  ENABLED: ['true', '1'].includes(import.meta.env.VITE_ENABLE_SENTRY || ''),
};
